import anime from "animejs/lib/anime.es.js";
import Highway from "@dogstudio/highway";

import Cards from "../components/cards";
import Map from "../components/map";

import CarouselIntro from "../components/carouselIntro";
import CarouselHover from "../components/carouselHover";
import SliderBuilding from "../components/sliderBuilding";

var homeObject = {};

class Home extends Highway.Renderer {
  onEnter() {
    homeObject.carouselIntro = new CarouselIntro().init();
    homeObject.carouselHover = new CarouselHover().init();
    homeObject.sliderBuilding = new SliderBuilding().init();
    homeObject.cards = new Cards().init();
    homeObject.map = new Map().init();
  }
  onEnterCompleted() {}

  onLeave() {}

  onLeaveCompleted() {
    homeObject = {};
  }
}

export default Home;



// WEBPACK FOOTER //
// ./scripts/routes/home.js